export default (HTTPClient, HTTPClientMultiForm) => ({
  readOne: async (id) => {
    const resp = await HTTPClient.get(`bo/student-exams/${id}`);
    return resp;
  },
  recalculateScores: async (id) => {
    const resp = await HTTPClient.get(`student-exams/${id}/recalculate-scores`);
    return resp;
  },
  orderExamQuestions: async (file) => {
    const form = new FormData();
    form.append('csvFile', file);
    await HTTPClientMultiForm.post('student-exams/order-questions', { body: form });
  },
});
